import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { OldFooter } from '@widgets/footer';
import { useWebView } from '@shared/lib/web-view';
import FullViewportHeightSection from './FullViewportHeightSection';
import SectionBg from './SectionBg';
import Title from './Title';
import FAQ from './FAQ';
import faqBgDesktop from '../../assets/new-year/faq-bg-desktop.jpg';
import faqBgTablet from '../../assets/new-year/faq-bg-tablet.jpg';
import faqBgMobile from '../../assets/new-year/faq-bg-mobile.jpg';
const FAQSectionView: FC = () => {
  const {
    isWebView
  } = useWebView();
  return <FullViewportHeightSection faq>
      <SectionBg faq desktopImg={faqBgDesktop} tabletImg={faqBgTablet} mobileImg={faqBgMobile}>
        <FAQSectionViewWrapper>
          <TextWrapper>
            <Title>вопросы и ответы</Title>
          </TextWrapper>
          <FAQWrapper>
            <FAQ />
          </FAQWrapper>
          <FooterWrapper>
            <OldFooter isWebView={isWebView} />
          </FooterWrapper>
        </FAQSectionViewWrapper>
      </SectionBg>
    </FullViewportHeightSection>;
};
export default FAQSectionView;
const FAQSectionViewWrapper = /*#__PURE__*/styled('div')({
  name: "FAQSectionViewWrapper",
  class: "f10pvinw",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1bh8vw4",
  propsAsIs: false
});
const FAQWrapper = /*#__PURE__*/styled('div')({
  name: "FAQWrapper",
  class: "f1defj7n",
  propsAsIs: false
});
const FooterWrapper = /*#__PURE__*/styled('div')({
  name: "FooterWrapper",
  class: "fkgeo16",
  propsAsIs: false
});

require("./FAQSectionView.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FAQSectionView.tsx");